/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetUserByUserUuidDataDto
 */
export interface GetUserByUserUuidDataDto {
    /**
     * 닉네임
     * @type {string}
     * @memberof GetUserByUserUuidDataDto
     */
    'nickname': string;
    /**
     * 프로필 사진
     * @type {string}
     * @memberof GetUserByUserUuidDataDto
     */
    'profileImg': string;
    /**
     * 유저 레벨
     * @type {string}
     * @memberof GetUserByUserUuidDataDto
     */
    'level'?: GetUserByUserUuidDataDtoLevelEnum;
    /**
     * 유저 레벨 진행 퍼센트
     * @type {number}
     * @memberof GetUserByUserUuidDataDto
     */
    'levelProgress'?: number;
    /**
     * 서포터즈 여부
     * @type {boolean}
     * @memberof GetUserByUserUuidDataDto
     */
    'isSupporter'?: boolean;
    /**
     * 수호신 여부
     * @type {boolean}
     * @memberof GetUserByUserUuidDataDto
     */
    'isGuardian'?: boolean;
    /**
     * 현재 유저의 총 포인트
     * @type {number}
     * @memberof GetUserByUserUuidDataDto
     */
    'totalPoint'?: number;
}

export const GetUserByUserUuidDataDtoLevelEnum = {
    Baby: 'baby',
    Friends: 'friends',
    Family: 'family',
    Supporters: 'supporters',
    Guardian: 'guardian',
    Both: 'both'
} as const;

export type GetUserByUserUuidDataDtoLevelEnum = typeof GetUserByUserUuidDataDtoLevelEnum[keyof typeof GetUserByUserUuidDataDtoLevelEnum];


